import { CardBlock, IconFeatureCard } from "@repo/ui/components/common/cms";
import type { LinkedItem } from "@repo/ui/types/cms/common";

import HeaderLayout from "../HeaderLayout";

interface ReservationsProps {
  linkedItems: LinkedItem[];
  title?: string;
}

export default function Reservations({ linkedItems, title }: Readonly<ReservationsProps>) {
  const [features, reservationActions] = linkedItems;

  return (
    <HeaderLayout>
      <div className="container mx-auto space-y-4" data-testid="reservations-container">
        <h2
          className="text-brand-blue !p-0 text-2xl font-semibold"
          data-testid="reservations-title-lbl"
        >
          {title ?? ""}
        </h2>
        <div
          className="text-brand-blue container mx-auto"
          data-testid="reservations-actions-section"
        >
          <div
            className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4"
            data-testid="reservations-actions-grid"
          >
            {reservationActions?.card_block?.map((item) => (
              <CardBlock key={item.title} item={item} />
            ))}
          </div>
        </div>

        <div className="container mx-auto pt-4" data-testid="reservations-features-section">
          <div
            className="md:mx-8 md:mt-4 md:mb-8 flex flex-col gap-4 md:grid md:grid-cols-3"
            data-testid="reservations-features-grid"
          >
            {features?.icon_feature_cards?.map((item) => (
              <IconFeatureCard
                key={item.title}
                item={item}
                testId={`reservations-feature-card-${item.title.replace(/\s+/g, "-").toLowerCase()}`}
              />
            ))}
          </div>
        </div>
      </div>
    </HeaderLayout>
  );
}
